import { Transform, Type } from "class-transformer";
import { BaseModel } from "../base.model";
import { FormTemplateQuestion } from "./form-template-question.model";
import { Question } from "./question.model";
import { VariantDeliveryMethod } from "./variant-delivery-method.model";

export class QuestionVariant extends BaseModel {
  id: number;
  @Transform(({ value }) => decodeURIComponent(value || ""))
  value: string;
  @Transform(({ value }) => decodeURIComponent(value || ""))
  shortValue: string;
  @Transform(({ value }) => decodeURIComponent(value || ""))
  description: string;
  @Transform(({ value }) => decodeURIComponent(value || ""))
  note: string;
  qId: number;
  variantDeliveryMethodId: number;
  @Type(() => VariantDeliveryMethod)
  variantDeliveryMethod: VariantDeliveryMethod;
  variantLanguageId: number;
  @Type(() => Question)
  question: Question;
  formTemplateQuestions: FormTemplateQuestion[];
  qVariantGroupId: number;
  @Type(() => Boolean)
  isArchived: boolean;
}
